<template>
  <div class="instructions">
    <p>This is a list of currently outstanding requests for PPE. Click on the requests below to see more details. If you have PPE that you can contribute to one of these requests, fill out the form associated with that request and deliver the PPE to the address provided. If you can commit to completing PPE within 7 days, please also fill out the form and deliver them to the organization as soon as they are ready.</p>
  </div>
</template>
<script>
export default {
  name: "Banner"
};
</script>
<style lang="scss" scoped>
.instructions {
  background-color: #fff;  
  width: 100%;
  padding: 25px 35px 25px 25px;
  @media screen and (min-color-index:0) and(-webkit-min-device-pixel-ratio:0) {
    margin: 100px 0 25px 0;
  }
	@media (max-width: $sm) {
		padding: 25px 20px 25px 10px;
	}
  p {
		color: #8b8795;
		font-weight: 700;
    font-size: 14px;
		// border: 1px solid #d83cb4;
		padding: 25px;
  }
}
</style>